function ShareIntroOptionCard({ option, selected, onSelect }) {
  const Icon = option.icon;

  return (
    <button
      type="button"
      onClick={() => onSelect(option.id)}
      className={`flex min-h-[66px] w-full items-start gap-3 rounded-xl border px-4 py-3 text-left transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#087a34] sm:min-h-[74px] ${
        selected
          ? "border-[#087a34] bg-[#f6faf3]"
          : "border-black/12 bg-white hover:border-[#087a34]/45"
      }`}
    >
      {Icon ? (
        <Icon
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`mt-0.5 h-5 w-5 shrink-0 ${
            selected ? "text-[#087a34]" : "text-black/42"
          }`}
        />
      ) : null}

      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold leading-tight text-[#071015]">
          {option.title}
        </span>
        <span className="mt-1 block text-sm font-medium italic leading-snug text-[#273119] sm:text-[0.95rem]">
          &quot;{option.quote}&quot;
        </span>
      </span>

      <span
        className={`flex h-6 w-6 shrink-0 self-center items-center justify-center rounded-full border-2 ${
          selected
            ? "border-[#087a34] bg-[#087a34] text-white"
            : "border-black/24 text-transparent"
        }`}
      >
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4"
        >
          <path d="m5 12 4 4L19 6" />
        </svg>
      </span>
    </button>
  );
}

export default ShareIntroOptionCard;
